<template>
  <div class="board-cards">
      <poker-card class="card" :card="card" v-for="card in cards" :key="card">
      </poker-card>
  </div>
</template>

<script>
import Card from '../PokerCard.vue';

export default {
  components: {
    'poker-card': Card
  },
  props: {
    cards: Array
  }
}
</script>

<style scoped>
.board-cards {
  position: absolute;
  top: 300px;
  width: 144px;
  left: 140px;
}
.card {
  margin-left: 4px;
  display: inline-flex;
  top: 3px;
}

.no-pad {
  padding: 4px;
}
</style>
